<template>
  <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.otpVerificationDigital"
    ui-title=""
    ui-subtitle=""
    :ui-error-message="getOtpCodeErrorMessage()"
    ui-button-text="Confirm"
   
  >
 <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep3" ui-title="" >
         
      </FieldsetModel> -->
       <FieldsetModel :ui="uiBaseFieldset" name="fieldSetOTPVerification" >
      <p style=" color: #6e3dea;
  font-weight: 500;
  font-size: 30px;padding-bottom:20px">Let's confirm your mobile number</p>

       </FieldsetModel>
   <!-- ui-secondary-button="Change phone"
    :ui-secondary-action="changePhoneAction" -->
    <FieldsetOtp
      ref="otpFieldset"
      :title="otpSubtitleDigital"
      subtitle=""
      :on-change="resetOtpService()"
      :resend-code="resendOtpCode"
    />
  </StepModel>
</template>


<script>
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Models
import StepModel from "@/lib/components/models/step";
import FieldsetOtp from "@/forms/components/shared/fieldsets/otp";

import FormComponentMixin from "@/lib/mixins/form-component-mixin";

import otpService from "@/forms/api/services/otp";
import otpServiceReferal from '@/forms/api/services/otp-referral';
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import resetService from "@/lib/helpers/reset-service";

import FIELD_NAMES from "@/forms/constants/field-names";
import FieldsetModel from "@/lib/components/models/fieldset";


import { OTP_VALIDATE } from "@/forms/constants/services";

export default {
  name: "OtpStep",

  mixins: [FormComponentMixin],

  props: {
    title: {
      type: String,
      default: "Contact Verification"
    },
    subtitle: {
      type: String,
      default: "Let’s verify your mobile number to make sure we can reach you"
    },
    changePhoneAction: {
      type: Function,
      default: () => {}
    }
  },

  components: {
    StepModel,
    FieldsetOtp,
    FieldsetModel
  },
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  computed: {
    otpSubtitle() {
      const { values } = this.$store.state.formData;
      const phone = getValueByFieldName(values, FIELD_NAMES.phoneNumber) || "";
      const prefix = phone.substring(0, 2);
      const suffix = phone.substring(2);
      return `We have sent it to +971-${prefix}-${suffix}`;
    },
    otpSubtitleDigital() {
      const { values } = this.$store.state.formData;
      const phone = getValueByFieldName(values, FIELD_NAMES.phoneNumber) || "";
      const prefix = phone.substring(0, 2);
      const suffix = phone.substring(2);
      return `Please enter the 6-digit OTP sent to your mobile(${'0'+phone})`;
    }
  },

  methods: {
    getOtpCodeErrorMessage() {
      const { otpFieldset } = this.$refs;
      if (otpFieldset) {
        return otpFieldset.getErrorMessage;
      }
      return null;
    },

    async resendOtpCode() {
      const response = await otpService.resendOtpV2();
      return !!response;
    },

    resetOtpService() {
      return () => resetService(OTP_VALIDATE);
    }
  }
};
</script>
<style >
/* Progess Bar with steps */
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
 

}
.step-counter.active{
  background-color: #6e3dea;
}

.stepper-item.completed .step-counter {
  background-color: #6e3dea;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  /* border-bottom: 2px solid #6e3dea; */
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}
</style>
